
import { Component, Vue } from "vue-property-decorator";
import Pagina from "@/components/Pagina/PaginaPreview.vue";

@Component({
  components: {
    Pagina
  }
})
export default class PreviewView extends Vue {}
